import { useEffect, useState } from 'react';

import { client, useErrorNotifications } from 'core/http';
import { CustomerTire, CustomerTireMeta } from 'core/types/customerTire';

export default function useCustomerTires(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [loading, setLoading] = useState(false);
  const [tires, setTires] = useState<CustomerTire[]>([]);
  const [tireMeta, setTireMeta] = useState<CustomerTireMeta>();

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);

    client()
      .get<{ data: CustomerTire[]; meta: CustomerTireMeta }>(
        `customers/${customerId}/tires`
      )
      .then((response) => {
        setTires(response.data.data);
        setTireMeta(response.data.meta);
      })
      .catch(showErrorNotification)
      .finally(() => setLoading(false));
  }, [customerId, showErrorNotification]);

  return { tires, tireMeta, loading };
}
